import { twMerge } from "tailwind-merge";

const LeftArrowBox = ({ className }: { className?: string }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge(
        "hover:fill-[#58C1D7] [&>#arrow]:hover:fill-white",
        className
      )}
    >
      <path
        d="M35.8333 1L4.16667 1C2.41776 1 1 2.41776 1 4.16667L1 35.8333C1 37.5822 2.41776 39 4.16667 39L35.8333 39C37.5822 39 39 37.5822 39 35.8333L39 4.16667C39 2.41776 37.5822 1 35.8333 1Z"
        fill="white"
      />
      <path
        d="M35.8328 1.63281L4.16615 1.63281C2.76702 1.63281 1.63281 2.76702 1.63281 4.16615L1.63281 35.8328C1.63281 37.2319 2.76702 38.3661 4.16615 38.3661L35.8328 38.3661C37.2319 38.3661 38.3661 37.2319 38.3661 35.8328L38.3661 4.16615C38.3661 2.76702 37.2319 1.63281 35.8328 1.63281Z"
        stroke="#58C1D7"
        strokeWidth="2"
      />
      <path
        d="M13.8904 19.7838L18.0469 15.7748C18.1853 15.642 18.3694 15.5674 18.5612 15.5664C18.7088 15.5668 18.853 15.6112 18.9753 15.694C19.0975 15.7768 19.1923 15.8942 19.2476 16.0311C19.3028 16.1681 19.3159 16.3184 19.2852 16.4628C19.2546 16.6072 19.1815 16.7392 19.0755 16.8419L16.335 19.4855L25.4956 19.4855C25.7158 19.4855 25.9271 19.573 26.0829 19.7288C26.2387 19.8845 26.3262 20.0958 26.3262 20.3161C26.3262 20.5364 26.2387 20.7477 26.0829 20.9034C25.9271 21.0592 25.7158 21.1467 25.4956 21.1467L16.335 21.1467L19.0761 23.7928C19.2176 23.9292 19.2991 24.1162 19.3028 24.3127C19.3064 24.5092 19.2318 24.6991 19.0954 24.8406C18.959 24.9821 18.772 25.0637 18.5755 25.0673C18.379 25.0709 18.1891 24.9963 18.0476 24.8599L13.891 20.8509C13.8197 20.7813 13.763 20.6982 13.7242 20.6064C13.6854 20.5146 13.6652 20.4161 13.6649 20.3164C13.665 20.2172 13.6851 20.119 13.7238 20.0276C13.7625 19.9362 13.8191 19.8535 13.8904 19.7844"
        fill="#58C1D7"
        id="arrow"
      />
    </svg>
  );
};

export default LeftArrowBox;
